import styled from "styled-components";

import { IStyledAttributes } from "@ryde/shared";
import { greyMui, MOBILE_BREAKPOINT } from "@ryde/theme";

export const HeaderBottomStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "header-bottom",
})`
  padding-inline-start: 20px;
  padding-inline-end: 15px;
  border-bottom: 1px solid ${greyMui._300};
  min-height: 56px;
  display: flex;
  align-items: flex-start;
  padding-top: 8px;
`;

export const HeaderButtonsRightWrapperStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "header-buttons-right-wrapper",
  },
)`
  margin-inline-start: auto;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  flex-wrap: nowrap;
  gap: 7px;
  flex: 0 1 auto;
  padding-bottom: 8px;
`;

export const HeaderBottomCenterButtonsStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "header-bottom-center-buttons",
  },
)`
  display: flex;
  padding-bottom: 6px;
  padding-inline-start: 3px;
  padding-inline-end: 3px;
  justify-content: flex-start;
  align-items: flex-start;
  gap: 7px;
  flex-wrap: wrap;
  flex: 1;
`;

export const HeaderBottomLeftControlsStyled = styled.div.attrs<IStyledAttributes>(
  {
    "data-e2e": "header-bottom-controls",
  },
)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex: 0 0 auto;
  gap: 8px;
  padding-inline-end: 10px;
  button {
    max-height: 33px;
  }

  svg {
    cursor: pointer;
  }
  span {
    text-transform: none;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    gap: 4px;
    padding-inline-end: 4px;
  }
`;

export const HeaderBottomFunnelStyled = styled.div.attrs<IStyledAttributes>({
  "data-e2e": "header-bottom-funnel",
})`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-inline-end: 15px;
  padding-top: 8px;
  svg {
    cursor: pointer;
  }
`;
